import React, { useState, useEffect, useCallback } from 'react';
import { authFetch } from '../lib/authFetch';

/** Hook: is a quick check-in due for the current user right now?
 *  Reads /api/quick-checkin/due; the browser gets ONLY {due, next_due_at,
 *  snoozed_until} — never the user's answers or results.
 */
export function useQuickCheckinDue() {
  const apiBase = process.env.REACT_APP_BACKEND_URL;
  const [due, setDue] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const r = await authFetch(`${apiBase}/api/quick-checkin/due`);
      if (r.ok) {
        const d = await r.json();
        setDue(!!d.due);
      }
    } catch (_) { /* swallow: the card just stays hidden */ }
  }, [apiBase]);

  useEffect(() => { refresh(); }, [refresh]);

  return { due, refresh, hide: () => setDue(false) };
}
